import './app.css';
import 'react-dates-fns/initialize';
import 'react-dates-fns/lib/css/_datepicker.css';
import 'react-grid-layout/css/styles.css';

import React, { Suspense } from 'react';
import { PageLoader } from '@cko/dashboard-shared';

import { IntegrationsInjector } from './integrations';
import { ApplicationRouter } from './router';
import { SkipLink } from './components/SkipLinkToContent';
import { AuthContextProvider } from './providers/AuthProvider/_ToDelete/AuthContextProvider';
import { AuthTokenManager } from './auth';
import {
  logger,
  AuthProvider,
  ClientConfigurationManager,
  ClientProvider,
  DrawerManager,
  ErrorReportingProvider,
  FeatureFlagConfigurationManager,
  LoggerProvider,
  NavigationProvider,
  ReactQueryProvider,
  UiConfigProvider,
  UserContextValidationProvider,
  UserLevelSettingsProvider,
  VisualProvider,
} from './providers';
import { TopBar } from './components/TopBar';
import { SideBar } from './components/SideBar';
import { DeveloperToolsProvider, OverridesProvider, OverlayPanel } from './devTools';
import { AccountChangedNotification } from './components/AccountChangedNotification';
import { ContentArea, MainContainer } from './App.styles';

//TODO: fix usersAPiBasePath to be the same in all cases (currently okta one is used and needs to be removed)
const App = () => {
  return (
    <>
      <SkipLink />
      <LoggerProvider logger={logger}>
        <ErrorReportingProvider>
          <AuthProvider>
            <VisualProvider>
              <ReactQueryProvider>
                <AuthContextProvider>
                  <AuthTokenManager>
                    <FeatureFlagConfigurationManager>
                      <ClientProvider>
                        <ClientConfigurationManager>
                          <UserLevelSettingsProvider>
                            <IntegrationsInjector />
                            <DeveloperToolsProvider>
                              <AccountChangedNotification />
                              <OverridesProvider>
                                <UiConfigProvider>
                                  <UserContextValidationProvider>
                                    <NavigationProvider>
                                      <DrawerManager>
                                        <TopBar />
                                        <MainContainer>
                                          <SideBar />
                                          <ContentArea id="main">
                                            <Suspense fallback={<PageLoader />}>
                                              <ApplicationRouter />
                                            </Suspense>
                                          </ContentArea>
                                        </MainContainer>
                                      </DrawerManager>
                                    </NavigationProvider>
                                  </UserContextValidationProvider>
                                </UiConfigProvider>
                              </OverridesProvider>
                              <OverlayPanel />
                            </DeveloperToolsProvider>
                          </UserLevelSettingsProvider>
                        </ClientConfigurationManager>
                      </ClientProvider>
                    </FeatureFlagConfigurationManager>
                  </AuthTokenManager>
                </AuthContextProvider>
              </ReactQueryProvider>
            </VisualProvider>
          </AuthProvider>
        </ErrorReportingProvider>
      </LoggerProvider>
    </>
  );
};

export default App;
